import { messageToNativeClient } from "../../../Common/utils/platformCommunicationUtil"
import useRestrictions from "../data/useRestrictions";

export default function usePlatformCommunication() {
    const { restrictionCheck, location_addcash } = useRestrictions();

    const walletNavigation = () => {
        messageToNativeClient({ type: "openMyWallet", isOpened: true });
    }

    const addCashNavigation = () => restrictionCheck(() => {
        messageToNativeClient({ type: "openaddcash" })
    }, false, location_addcash)

    return { walletNavigation, addCashNavigation }
}
